export default __webpack_public_path__ + "static/media/zencard.47c7694d.png";